export const fieldsLabels = {
	['continue']: 'Continuar',
	['cancel']: 'Cancelar',
	['clone-case']: 'Clonar Caso',
	['create']: 'Criar',
	['table-save']: 'Salvar',
	['table-cancel']: 'Cancelar',
	['item-added']: 'adicionado',
	['item-removed']: 'removido',
	['item-registered']: 'cadastrado e selecionado',
	['paginator-separator']: 'de',
	['search-default-placeholder']: 'Localize os casos a partir da pesquisa por qualquer coluna',
	['table-not-found']: 'Que pena, não encontramos nada!',
	['generic-infos-filled']: 'Informações à preencher',
	['generic-try-start-task']: 'Inicie a tarefa',
	['table-selecteds']: 'Selecionado(s):',
	['table-selected']: 'Selecionado:',
	['table-try-new-search']: 'Você pode tentar refazer a pesquisa',
	['table-nothing-selected']: 'Nenhum registro foi selecionado',
	['login-enter']: 'Entrar',
	['login-forgot-password']: 'Esqueci minha senha',
	['login-password-invalid']: 'E-mail ou senha incorreta.',
	['login-password-possible-redefine']: 'Mas é possível cadastrar uma nova senha caso precise.',
	['login-you-must-been-absent']: 'Parece que você ficou um tempo fora!',
	['login-do-again']: 'Faça o login novamente',
	['new-entity']: 'Cadastrar',
	['hour']: 'Hora',
	['minute']: 'Minuto',
	['new-register']: 'Cadastro Novo',
	['back']: 'Voltar',
	['register-case']: 'Cadastrar Caso',
	['create-task']: 'Criar tarefa',
	['searching']: 'Pesquisando...',
};
